module.exports = __webpack_public_path__ + "img/7.0c9cb07c.jpg";